import { EducationAndQualificationList } from "@/routes/_staff/person/$id/_profile/education-and-qualification";
import { EducationAndQualificationSearchSchema } from "@/routes/_staff/person/$id/_profile/education-and-qualification/certification/-zod-schema";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

export const Route = createFileRoute(
  "/_staff/person/alumni/$id/_profile/education-and-qualification/",
)({
  component: EducationAndQualificationList,
  validateSearch: zodValidator(EducationAndQualificationSearchSchema),
});
